import { render, staticRenderFns } from "./TuloraConfig.vue?vue&type=template&id=53b49b7e&"
import script from "./TuloraConfig.vue?vue&type=script&lang=js&"
export * from "./TuloraConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports